<script setup lang="ts">
import {ref} from "vue";
import {Briefcase, Contact, Home, Info, Menu, ShoppingBag, Wrench, X} from "lucide-vue-next";

import '@/assets/styles/sidebar.css';

const isOpen = ref(false);

const toggleSidebar = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <div>
    <button v-if="!isOpen" class="menu" type="button" aria-label="Menü öffnen" @click="toggleSidebar">
      <Menu/>
    </button>

    <div v-if="isOpen" class="overlay" @click="toggleSidebar"/>
  </div>

  <aside class="sidebar" :class="{open: isOpen}" aria-label="Mobile Navigation">
    <div class="header">
      <button class="close-btn" type="button" aria-label="Menü schließen" @click="toggleSidebar">
        <X/>
      </button>
      <img class="logo" src="/logo.png" alt="Firmenlogo"/>
      <h1>KFZ Musterwerkstatt</h1>
    </div>

    <nav class="points">
      <router-link to="/" @click="toggleSidebar" class="points-link">
        <Home/>
        Home
      </router-link>
      <router-link to="/about" @click="toggleSidebar" class="points-link">
        <Info/>
        Über uns
      </router-link>
      <router-link to="/services" @click="toggleSidebar" class="points-link">
        <Wrench/>
        Leistungen
      </router-link>
      <router-link to="/products" @click="toggleSidebar" class="points-link">
        <ShoppingBag/>
        Produkte
      </router-link>
      <router-link to="/career" @click="toggleSidebar" class="points-link">
        <Briefcase/>
        Karriere
      </router-link>
      <router-link to="/contact" @click="toggleSidebar" class="points-link">
        <Contact/>
        Kontakt
      </router-link>
    </nav>
  </aside>
</template>

<style scoped>
</style>
